import { SPB_CITY_CODE } from '../model'

const LOCAL_DOMAIN = `local`

export const getRegionDomain = (cityCode: string): string => {
	const isMainRegion = cityCode === SPB_CITY_CODE
	const regionCode = isMainRegion ? `www.` : cityCode + `.`
	const { protocol, hostname, pathname, port: currentPort } = window.location
	const hostParsed = hostname.split(`.`).reverse()
	const isLocalhost = hostname.includes(LOCAL_DOMAIN)

	const rootHost = `${isLocalhost ? `${LOCAL_DOMAIN}.` : ``}${hostParsed[1]}.${hostParsed[0]}`
	const port = !isLocalhost
		? ``
		: currentPort
		? `:${currentPort}`
		: isMainRegion
		? `:3000` // или ваш реальный порт для main региона
		: `:3001` // или ваш реальный порт для других регионов

	return `${protocol}//${regionCode}${rootHost}${port}${pathname}`
}
